import { HeroCarousel as HeroCarouselUI } from "@repo/ui-parkmobile/HeroCarousel";
import type { HeroCarousel, SectionTitle } from "@/generated/sb";
import {
  imageStoryblokResolver,
  sectionTitleResolver,
} from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";

interface HeroCarouselProps {
  blok: HeroCarousel;
}

export default function HeroCarousel({ blok }: HeroCarouselProps) {
  if (!blok) {
    return null;
  }

  const imageBlok = blok.backgroundImage?.[0];
  const imageAsset = imageStoryblokResolver(imageBlok);

  const slides =
    blok.slides
      ?.map((slide: SectionTitle) => {
        // sectionTitleResolver now handles layout automatically from slide.layout
        const sectionTitle = sectionTitleResolver([slide]);

        return {
          sectionTitle: sectionTitle || undefined,
          ...storyblokEditable(slide),
        };
      })
      .filter((slide) => slide.sectionTitle !== undefined) || [];

  return (
    <HeroCarouselUI
      {...storyblokEditable(blok)}
      image={imageAsset}
      backgroundOverlay={blok.backgroundOverlay || "brand-50"}
      backgroundOverlayColor={"primary"}
      slides={slides}
      backgroundColor={blok.backgroundColor || "none"}
      topPadding={blok.topPadding || "none"}
      bottomPadding={blok.bottomPadding || "none"}
      id={blok.anchor}
    />
  );
}
